const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaSelect: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'HOSPITAL_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'HOSPITAL_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'HOSPITAL_LISTADO':            
            return {
                ...state, 
                lista: action.payload.data,
                listaSelect: action.payload.data.map(item => ({
                    id: item.id,
                    valor: item.nome_fantasia,
                    importacao_convenio: item.importacao_convenio,
					importacao_sigla_exame: item.importacao_sigla_exame,
					importacao_observacao_exame: item.importacao_observacao_exame,
					importacao_radiologista: item.importacao_radiologista,
					importacao_nome_paciente: item.importacao_nome_paciente,
					importacao_data_exame: item.importacao_data_exame,
					importacao_quantidade: item.importacao_quantidade,
					importacao_laudo: item.importacao_laudo,
					importacao_medico_solicitante: item.importacao_medico_solicitante,
				    importacao_digitador: item.importacao_digitador
                }))
            };

        default:
            return state;
    }
}
